import React from "react";
import TextField from '@material-ui/core/TextField';
import {
  makeStyles,
} from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    // marginTop: -50,
    display: 'flex',
    flexWrap: 'wrap',
    marginBottom: 35,
    justifyContent: 'center'
  },
  margin: {
    margin: theme.spacing(1),
  },
  textFieldNroAut: {
    '& input:valid + fieldset': {
      borderColor: 'green',
      borderWidth: 3,
    },
    '& input:valid:focus + fieldset': {
      borderWidth: 3,
      borderColor: 'green',
      cursor: 'norAllowed'
    },
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: 'green',
      },      
    },
    '& input': {
      padding: 10,
      fontSize: 17,
      cursor: 'default',
      fontWeight: 'bold',
    },
    textAlignLast: 'center',
    textShadow: '0 0 black'
  },
}));

export const PracticaNroAutorizacion = ({nroAutorizacion, domiciliaria = false}) => {
  const classes = useStyles();

  return (
    <form 
      className={classes.root} 
      style={{marginTop: !domiciliaria ? -60 : 10}} 
      noValidate
    >
      <TextField
        className={classes.textFieldNroAut}
        label="Nro Autorización"
        value={nroAutorizacion}
        variant="outlined"
      />
    </form>
  )
}